/**
 * Why the server refused a request, in its own words.
 *
 * A refusal names the rule that applied (the console may not grant a
 * client's Admin role, a configuration route admits the console but not an
 * API key, a search reads content the console is never sent, #10718), and a
 * generic "Failed to ..." hides which one. The API answers `{"detail": ...}`
 * (django-ninja's `HttpError`) and a few legacy routes `{"error": ...}`;
 * either is the reason. `fallback` when the body carries neither, is not
 * JSON, or there is no body at all (fpFetch's no-response stand-in).
 */
export async function serverReason(
  response: { json?: () => Promise<unknown> } | null | undefined,
  fallback: string
): Promise<string> {
  try {
    const body = (await response?.json?.()) as
      | { detail?: unknown; error?: unknown }
      | null
      | undefined;
    const reason = body?.detail ?? body?.error;
    return typeof reason === "string" && reason.trim() !== ""
      ? reason
      : fallback;
  } catch {
    return fallback;
  }
}
